export type ErrorType = 'gateway_error' | 'unknown_error';

export interface ErrorObject {
  type: ErrorType,
  message: string
}

const JS_ERR_NUMBER_PREFIX = `98`;

export function createUnknownErrorObject(type: ErrorType): ErrorObject {
  return {
    type: type,
    message: `ERR#${JS_ERR_NUMBER_PREFIX}${nextErrorNumber()}`
  }
}

function nextErrorNumber(): number {
  return Math.floor(Math.random() * 99999) + 1;
}